<template>

<div>

    <h1>Create new supplier</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createSupplier">

        <SupplierFields></SupplierFields>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create supplier</button>
          </div>
        </div>

      </form>
    </div>

</div>

</template>

<script>
import SupplierFields from '@/components/SupplierFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'SupplierCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      supplier: {},
      countries: null,
      referrers: null,
      errors: null
    }
  },
  components: {
    SupplierFields,
    Errors
  },
  methods: {
    createSupplier () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'suppliers', {
        method: 'POST',
        body: JSON.stringify(this.supplier),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'supplier-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
